import { RunStatusTag, type RunStatus } from "../../components/ui";
import type { AgentRunState } from "../api/e2e";

function agentStateLabel(state: AgentRunState): string {
  if (state.kind === "draft") {
    return state.input_readiness === "ready"
      ? "Draft ready"
      : "Draft incomplete";
  }
  if (state.kind === "queued") return "Queued";
  if (state.kind === "active") {
    switch (state.phase) {
      case "preparing":
        return "Preparing";
      case "sandboxing":
        return "Building";
      case "certifying":
        return "Certifying";
      case "publishing":
        return "Publishing";
    }
  }
  switch (state.outcome) {
    case "succeeded":
      return "Succeeded";
    case "failed":
      return "Failed";
    case "canceled":
      return "Canceled";
    case "expired":
      return "Expired";
  }
}

function agentRunStatus(state: AgentRunState): RunStatus {
  return state.kind === "terminal" ? state.outcome : state.kind;
}

export default function AgentStatusPill({ state }: { state: AgentRunState }) {
  return (
    <RunStatusTag status={agentRunStatus(state)} className="agent-status-pill">
      {agentStateLabel(state)}
    </RunStatusTag>
  );
}
